module.exports = __webpack_public_path__ + "static/media/tired.29d5e5a7.svg";